<!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0 pagination-block" *ngIf="paginator.totalPages > 1"> -->
<div class="pagination-block" *ngIf="paginator.totalPages > 1">
	<ul>
		<li [attr.disabled]="!hasPreviousPage()" [class.disabled]="!hasPreviousPage()" (click)="previousPage(currentPage() - 1)"><</li>

		<ng-container *ngFor="let page of createRange(paginator.totalPages);first as first;last as last;">
			<ng-container *ngIf="first && hasPreviousPage()">
				<li (click)="pageChange(0)">First</li>
				<li>...</li>
			</ng-container>
			<li
				[class.active]="page === currentPage()"
				(click)="pageChange(page)"
				*ngIf="pagingDisplayRange(currentPage()).includes(page)"
			>
				{{page+1}}
			</li>
			<ng-container *ngIf="last && hasNextPage()">
				<li>...</li>
				<li (click)="pageChange(paginator.totalPages - 1)">Last</li>
			</ng-container>
		</ng-container>
		<li [attr.disabled]="!hasNextPage()" [class.disabled]="!hasNextPage()" (click)="nextPage(currentPage() + 1)">></li>
	</ul>
</div>
